import {
	ConverterOperation,
	ConverterOperationInterface,
	Parameter
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {Internal} from "./Internal";

export interface PortalConverterOperationInterface extends ConverterOperationInterface {
	internal?: Internal;
}

export class PortalConverterOperation extends ConverterOperation
	implements PortalConverterOperationInterface, Parameter {
	internal?: Internal;

	constructor(data: any) {
		super(data);
		this.internal = Internal.fromJson(data?.internal);
	}

	public static fromJson(data: any): PortalConverterOperation {
		if (data === undefined || data === null) {
			return data;
		}

		return new PortalConverterOperation(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'internal': this.internal?.toJson()
		};
	}

	public clone(): PortalConverterOperation {
		return PortalConverterOperation.fromJson(this.toJson());
	}
}